import { Component, OnInit } from '@angular/core';
import { WebService } from '../shared/services/web.service';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import cloneDeep from 'lodash/cloneDeep';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { AwsService } from '../shared/services/aws-service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { HttpHeaders } from '@angular/common/http';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import { ChangeDetectorRef } from '@angular/core';
import { fadeIn } from '../../app/shared/animation/animation.component';
import { messages } from '../../app/shared/constant/message.constant.js';
import { normalizeQuillColorHtml } from '../../../quill.config';
import Quill from 'quill';
import * as pdfjsLib from 'pdfjs-dist';

/** Estimated seconds of reading time per PDF page for attachment duration labels. */
const PDF_READ_SECONDS_PER_PAGE = 90;
/** Fallback when page count cannot be read. */
const PDF_READ_SECONDS_DEFAULT = 180;

interface DataItem {
  course_name: string;
  chapter_count: any;
  popularity: string;
  uploaded_date: string;
  expires_date: string;
  tag: any;
  checked: boolean;
}

interface DataItems {
  chapter_name: string;
  engagement: any;
  tag: any;
  checked: boolean;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

interface ColumnItems {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItems> | null;
  sortDirections: NzTableSortOrder[];
}

interface ChapterAttachmentItem {
  tempId: string;
  chapter_attachment_relation_id?: number;
  file?: File;
  file_name: string;
  file_path?: string;
  file_type: string;
  fileUrl?: string;
  attachment_order: number;
  display_position: number;
  is_skippable: boolean;
  /** Video length in seconds (null for non-video / unknown) */
  duration_seconds?: number | null;
  isNew?: boolean;
}

@Component({
  selector: 'app-academy',
  templateUrl: './academy.component.html',
  styleUrls: ['./academy.component.css'],
  animations: [fadeIn],
})
export class AcademyComponent implements OnInit {
  academyCourseForm: FormGroup;
  academyChapterForm: FormGroup;
  /** Live Quill instance for chapter content — used so Save reads real HTML (incl. colors). */
  private chapterContentQuill: Quill | null = null;
  /** Text-only formatting — no image/video embeds */
  chapterContentEditorModules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ header: [1, 2, 3, false] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ['link', 'clean'],
      ],
      handlers: {
        // Keep black as an explicit inline color (Quill otherwise drops it).
        color(this: { quill: Quill }, value: string) {
          if (value) {
            const normalized =
              value === '#000000' || value === '#000' || value === 'black'
                ? '#000000'
                : value;
            this.quill.format('color', normalized);
          } else {
            this.quill.format('color', false);
          }
        },
      },
    },
  };
  metadata: any;
  courseData: any[];
  tagList: any[];
  tagFilterList: any[];
  academyCourseFormVisible: boolean = false;
  academyFormVisible: boolean = false;
  detailVisible: boolean = false;
  quizDetail: boolean = false;
  academy: any;
  selectedCourseChapters: any;
  tableDataRaw: any;
  academyForm: any;
  updateMode: boolean;
  formVisible: boolean;
  selectedCourseId;
  fileList: NzUploadFile;
  chapterAttachments: ChapterAttachmentItem[] = [];
  removedAttachmentPaths: string[] = [];
  displayPositionOptions = [
    { label: 'Above Content', value: 0 },
    { label: 'Below Content', value: 1 },
  ];
  submitted = false;

  selectedCourseChhapter: any = [];
  quizFormVisible: any = false;
  quizForm: FormGroup;
  tagCourseList: any[];
  tagCourseFilterList: any[];
  tagChapterList: any[];
  tagChapterFilterList: any[];
  radioValue = '0';
  createVisible: boolean = true;
  automaticVisible: boolean = false;
  selectedChapterId: any;
  quizzesForChapter: any;
  updateCourseId: any;
  rawUpdateData: any;
  updateModes: boolean;
  updateChapterId: any;
  courseThumbnailFile: File | null = null;
  courseThumbnailPreviewUrl: string | SafeUrl | null = null;
  courseThumbnailPathToDelete: string | null = null;
  private courseThumbnailObjectUrl: string | null = null;
  questionForm: FormGroup;
  options: FormArray;
  checkedData: any[];
  anyChecked: any;
  allChecked: any;
  courseDataRaw: any;
  selectedCourseChaptersRaw: any;
  course_category: any;
  courseCategory: any[];
  isSubmitFlag: boolean = false;
  isLoading: boolean = false;

  activeForm: FormGroup;
  searchTerm: string;
  searchTermChapter: string;
  Allmessages: {};
  Uploadprogress: Number = 0;
  // sortFn: (a: DataItem, b: DataItem) => {
  //   const nameA = a.chapter_count || '';
  //   const nameB = b.chapter_count || '';
  //   return nameA.localeCompare(nameB);
  // },
  isArchived: boolean = false;
  listOfColumns: ColumnItem[] = [
    {
      name: 'Courses',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.course_name.localeCompare(b.course_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Chapters',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => a.chapter_count - b.chapter_count,
      sortDirections: ['ascend', 'descend', null],
    },
    // {
    //   name: 'Popularity',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) =>
    //     a.course_name.localeCompare(b.popularity),
    //   sortDirections: ['ascend', 'descend', null],
    // },
    {
      name: 'Uploaded',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.uploaded_date.localeCompare(b.uploaded_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Expires',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.expires_date.localeCompare(b.expires_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Tags',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];

  listOfColumnsChapter: ColumnItems[] = [
    {
      name: 'Chapter',
      sortOrder: null,
      sortFn: (a: DataItems, b: DataItems) =>
        a.chapter_name.localeCompare(b.chapter_name),
      sortDirections: ['ascend', 'descend', null],
    },
    // {
    //   name: 'Engagement',
    //   sortOrder: null,
    //   sortFn: (a: DataItems, b: DataItems) => a.engagement - b.engagement,
    //   sortDirections: ['ascend', 'descend', null],
    // },
    {
      name: 'Tags',
      sortOrder: null,
      sortFn: (a: DataItems, b: DataItems) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];
  rawUpdateDatas: any;
  checkedDataCourse: any;
  anyCheckedChapter: any;
  allCheckedChapter: any;
  selectedCourseRaw: any;
  getCourseDataDetail: any;
  uploadedFileUrl: any;
  uploadedFileName: any;
  selectedCourseChaptersArray: any;
  currentSelectedCourseId: any;
  showLoad: boolean;
  isUsedInLast30Days: any;
  filterVisible: boolean;
  active: any;
  archived: any;
  appliedFilters: any[];
  checkboxChecked: boolean = false;
  checkboxDisabled: boolean = false;
  courseQuizChecked: boolean = false;
  courseQuizDisabled: boolean = false;
  sendNotificationOptions = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
  ];
  notificationRecurrenceOptions = Array.from({ length: 15 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1,
  }));
  timezones: any[] = [
    { value: "UTC", display: "UTC (Coordinated Universal Time)" },
    { value: "Pacific/Midway", display: "GMT-11:00 - Pacific/Midway" },
    { value: "America/Anchorage", display: "GMT-09:00 - America/Anchorage" },
    { value: "America/Los_Angeles", display: "GMT-08:00 - America/Los_Angeles (PST)" },
    { value: "America/Denver", display: "GMT-07:00 - America/Denver (MST)" },
    { value: "America/Chicago", display: "GMT-06:00 - America/Chicago (CST)" },
    { value: "America/New_York", display: "GMT-05:00 - America/New_York (EST)" },
    { value: "America/Sao_Paulo", display: "GMT-03:00 - America/Sao_Paulo (BRT)" },
    { value: "Atlantic/Azores", display: "GMT-01:00 - Atlantic/Azores" },
    { value: "Europe/London", display: "GMT+00:00 - Europe/London (GMT)" },
    { value: "Europe/Paris", display: "GMT+01:00 - Europe/Paris (CET)" },
    { value: "Europe/Istanbul", display: "GMT+03:00 - Europe/Istanbul (TRT)" },
    { value: "Africa/Cairo", display: "GMT+02:00 - Africa/Cairo (EET)" },
    { value: "Europe/Moscow", display: "GMT+03:00 - Europe/Moscow (MSK)" },
    { value: "Asia/Dubai", display: "GMT+04:00 - Asia/Dubai (GST)" },
    { value: "Asia/Karachi", display: "GMT+05:00 - Asia/Karachi (PKT)" },
    { value: "Asia/Kolkata", display: "GMT+05:30 - Asia/Kolkata (IST)" },
    { value: "Asia/Calcutta", display: "GMT+05:30 - Asia/Calcutta (IST)" },
    { value: "Asia/Dhaka", display: "GMT+06:00 - Asia/Dhaka (BST)" },
    { value: "Asia/Bangkok", display: "GMT+07:00 - Asia/Bangkok (ICT)" },
    { value: "Asia/Shanghai", display: "GMT+08:00 - Asia/Shanghai (CST)" },
    { value: "Asia/Tokyo", display: "GMT+09:00 - Asia/Tokyo (JST)" },
    { value: "Australia/Sydney", display: "GMT+10:00 - Australia/Sydney (AEST)" },
    { value: "Pacific/Noumea", display: "GMT+11:00 - Pacific/Noumea" },
    { value: "Pacific/Auckland", display: "GMT+12:00 - Pacific/Auckland (NZST)" },
    { value: "Pacific/Tongatapu", display: "GMT+13:00 - Pacific/Tongatapu" },
    { value: "America/Tijuana", display: "GMT-08:00 - America/Tijuana (PST)" },
    { value: "America/Phoenix", display: "GMT-07:00 - America/Phoenix (MST)" },
    { value: "America/Regina", display: "GMT-06:00 - America/Regina (CST)" },
    { value: "America/Bogota", display: "GMT-05:00 - America/Bogota (COT)" },
    { value: "America/Caracas", display: "GMT-04:00 - America/Caracas (VET)" }
  ];
  userCurrentTimezone: { display: string; value: string } = { display: '', value: '' };
  selectedtimezone:string;

  constructor(
    private webapi: WebService,
    private fb: FormBuilder,
    private awsService: AwsService,
    private notification: NzNotificationService,
    private modal: NzModalService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {
    this.academyCourseForm = this.fb.group({
      course_name: [null, [Validators.required]],
      // uploaded_date: [null, [Validators.required]],
      expires_date: [null, [Validators.required]],
      timezone: [null],
      category_id: [null, [Validators.required]],
      tag: [null],
      send_notification: [0],
      notification_recurrence: [2],
      image_path: [null],
    });

    this.academyChapterForm = this.fb.group({
      chapter_name: [null, [Validators.required]],
      description: [null, [Validators.required]],
      content: [null, [Validators.required]],
      File: [null],
      tag: [null],
    });
   
    

    this.questionForm = this.fb.group({
      quiz_name: ['', [Validators.required]],
      questions: this.fb.array(
        [],
        [Validators.required, this.validateQuestions]
      ),
    });

    this.activeForm = this.fb.group({
      is_active: [true],
    });

    this.courseData = [];
    this.getCourseList({ filters: [] });
    this.getMetadata();
    this.addQuestion();

  }

  getUserTimezone() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get user's timezone
    const offset = new Date().getTimezoneOffset(); // Get offset in minutes
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset <= 0 ? "+" : "-"; // Reverse sign because JavaScript gives it inverted
    const formattedOffset = `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

    return {display:`${formattedOffset} - ${tz}`, value:tz};
}
  confirmModal?: NzModalRef; // For testing by now
  showConfirm(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        this.academyCourseFormVisible = false;
      },
    });
  }
  showAlert(title, msg): void {
    this.confirmModal = this.modal.error({
      nzTitle: title,
      nzContent: msg,
      nzOnOk: () => {},
    });
  }

  showConfirmChapter(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        this.academyFormVisible = false;
        this.checkboxChecked = false;
      },
    });
  }
  showWarning():void{
    this.confirmModal = this.modal.info({
      
      nzTitle:
        "Action Not Allowed",
      nzContent: "You can't delete this question because the quiz must contain at least one. To disable the quiz, uncheck the 'Add a test to evaluate the learnings' checkbox in the bottom-left corner.",
      nzCentered: true,
    });
  }
  //Code for unsaved changes starts.
  originalFormValue: any; // Store the original form value
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    // Close the drawer if the form is empty
    this.academyCourseFormVisible = false;
  }
  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.academyCourseForm.value };
  }

  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.academyCourseForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (originalValue != currentValue) {
          return true; // Found a difference in form values
        }
      }
    }

    return false; // No differences found in form values
  }

  isFormNotEmpty(): boolean {
    if (this.academyCourseForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      for (const controlName in this.academyCourseForm.controls) {
        if (this.academyCourseForm.controls.hasOwnProperty(controlName)) {
          const control = this.academyCourseForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true; // Form control has a non-empty value
          }
        }
      }
      return false;
    }
  }

  ngOnInit() {
    this.awsService.setOriginalFormValue(this.academyChapterForm);  
  }

  ngAfterViewInit() {
    const currentTimeZone = momentTz.tz.guess(); // Get IANA name

    const currentTimeZoneMoment = momentTz().tz(currentTimeZone); // Create a moment object

    this.userCurrentTimezone = {
      display: `${currentTimeZoneMoment.format('z')} (${currentTimeZone})`, // Display with abbreviation and IANA name
      value: currentTimeZone // Store IANA name
    };
    
    this.academyCourseForm.patchValue({
        timezone: currentTimeZone // Use the IANA name for the form control
      });
      this.cdr.detectChanges();

    console.log("academyCourse", this.academyCourseForm.value);
    console.log("current timezone", this.userCurrentTimezone);
  }

  // checkFormStates(): void {
  //   const isAcademyChapterFormNotEmpty = this.awsService.isFormNotEmpty(
  //     this.academyChapterForm
  //   );
  //   const isQuestionFormNotEmpty = this.awsService.isFormNotEmpty(
  //     this.questionForm
  //   );

  //   if (isAcademyChapterFormNotEmpty || isQuestionFormNotEmpty) {
  //     this.awsService.showConfirm(
  //       'All unsaved changes will be lost. Do you still want to close the form?',
  //       () => {
  //         this.academyFormVisible = false;
  //       }
  //     );
  //   } else {

  //     this.academyFormVisible = false;
  //   }
  // }

  checkFormStates() {
    if (
      this.academyChapterForm.pristine &&
      this.questionForm.pristine &&
      this.activeForm.pristine &&
      this.chapterAttachments.length === 0
    ) {
      this.resetAcademyChapterForm();
      this.academyFormVisible = false;
      this.checkboxChecked = false;
      this.checkboxDisabled = false;
    } else {
      this.showConfirmChapter();
    }
  }

  getCourseList({ filters }, selectedCourseId=""): void {
    this.showLoad = true;
    this.webapi
      .requestJson('getCourse', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.courseData = [...response.data];
          this.courseData.forEach((kb) => {
            kb.checked = false;
          });

          this.courseDataRaw = cloneDeep(this.courseData);
          this.showLoad = false;
          if(selectedCourseId)
          this.displayChapters(selectedCourseId)
          // this.isLoading = false;
        },
        (error) => {
          this.showLoad = false;
          console.log('ERROR', error);
        }
      );
  }

  getMetadata(): void {
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['course_tags', 'chapter_tags', 'course_category'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.metadata = cloneDeep(response.data);
          this.courseCategory = [...this.metadata['courseCategory']];
          // this.courseData = [...this.metadata['courseData']];
          this.tagCourseList = [...this.metadata['courseTagCategory']];
          this.tagChapterList = [...this.metadata['chapterTagCategory']];

          this.tagCourseFilterList = [];
          this.tagCourseList.forEach((element) => {
            if (!element?.name || !String(element.name).trim()) {
              return;
            }
            this.tagCourseFilterList.push({
              text: element.name,
              value: element.tag_id,
              byDefault: false,
            });
          });

          this.tagChapterFilterList = [];
          this.tagChapterList.forEach((element) => {
            if (!element?.name || !String(element.name).trim()) {
              return;
            }
            this.tagChapterFilterList.push({
              text: element.name,
              value: element.tag_id,
              byDefault: false,
            });
          });
          console.log("tagChapterFilterList",this.tagChapterFilterList)
          if (this.metadata.courseCategory) {
            this.course_category = this.metadata.courseCategory;
          }

          // this.courseData.forEach((course) => {
          //   course.checked = false;
          //   course.chapters.forEach((chapter) => {
          //     chapter.checked = false;
          //   });
          // });

          // this.courseDataRaw = this.courseData;
        },
        (error) => {}
      );
  }

  closeDetail(): void {
    this.detailVisible = false;
  }

  closeQuizDetail(): void {
    this.quizDetail = false;
  }

  closeAcademyForm(): void {
    this.chapterContentQuill = null;
    this.resetAcademyChapterForm();
    this.academyFormVisible = false;
  }

  closeCourseAcademyForm() {
    this.clearCourseThumbnailState();
    this.academyCourseFormVisible = false;
  }

  clearCourseThumbnailState(): void {
    this.revokeCourseThumbnailObjectUrl();
    this.courseThumbnailFile = null;
    this.courseThumbnailPreviewUrl = null;
    this.courseThumbnailPathToDelete = null;
  }

  private revokeCourseThumbnailObjectUrl(): void {
    if (this.courseThumbnailObjectUrl) {
      URL.revokeObjectURL(this.courseThumbnailObjectUrl);
      this.courseThumbnailObjectUrl = null;
    }
  }

  getCourseThumbnailPreviewUrl(imagePath: string | null | undefined): string | null {
    if (!imagePath) {
      return null;
    }
    if (
      imagePath.startsWith('http://') ||
      imagePath.startsWith('https://') ||
      imagePath.startsWith('blob:') ||
      imagePath.startsWith('data:')
    ) {
      return imagePath;
    }
    return environment.BUCKET_URL + imagePath;
  }

  onCourseThumbnailSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) {
      return;
    }

    if (!file.type?.startsWith('image/')) {
      this.createNotification('error', '', 'Please select an image file.');
      input.value = '';
      return;
    }

    this.revokeCourseThumbnailObjectUrl();
    this.courseThumbnailFile = file;
    this.courseThumbnailObjectUrl = URL.createObjectURL(file);
    // Angular strips raw blob: URLs from [src]; bypass so the local preview renders.
    this.courseThumbnailPreviewUrl = this.sanitizer.bypassSecurityTrustUrl(
      this.courseThumbnailObjectUrl
    );
    input.value = '';
  }

  removeCourseThumbnail(): void {
    const existingPath = this.academyCourseForm.get('image_path')?.value;
    if (existingPath && !this.courseThumbnailFile) {
      this.courseThumbnailPathToDelete = existingPath;
    }

    this.revokeCourseThumbnailObjectUrl();
    this.courseThumbnailFile = null;
    this.courseThumbnailPreviewUrl = null;
    this.academyCourseForm.patchValue({ image_path: null });
  }

  private async uploadCourseThumbnailIfNeeded(): Promise<string | null> {
    if (!this.courseThumbnailFile) {
      return this.academyCourseForm.get('image_path')?.value || null;
    }

    const unixTimestamp = Date.now();
    const fileExtension = this.getFileExtension(this.courseThumbnailFile.name) || 'jpg';
    const combinedFileName = `course-thumbnail/${unixTimestamp}.${fileExtension}`;

    await this.awsService.uploadFile(
      this.courseThumbnailFile,
      combinedFileName,
      (progress) => {
        this.Uploadprogress = progress;
      }
    );

    if (this.courseThumbnailPathToDelete) {
      try {
        await this.awsService.deleteSingleFile(this.courseThumbnailPathToDelete);
      } catch (error) {
        console.log('Failed to delete old course thumbnail', error);
      }
      this.courseThumbnailPathToDelete = null;
    }

    this.courseThumbnailFile = null;
    this.revokeCourseThumbnailObjectUrl();
    this.academyCourseForm.patchValue({ image_path: combinedFileName });
    this.courseThumbnailPreviewUrl = this.getCourseThumbnailPreviewUrl(combinedFileName);
    return combinedFileName;
  }

  private async deleteRemovedCourseThumbnailIfNeeded(): Promise<void> {
    if (!this.courseThumbnailPathToDelete) {
      return;
    }
    try {
      await this.awsService.deleteSingleFile(this.courseThumbnailPathToDelete);
    } catch (error) {
      console.log('Failed to delete course thumbnail', error);
    }
    this.courseThumbnailPathToDelete = null;
  }

  // validateQuestions(control: FormArray): { [key: string]: boolean } | null {
  //   const questionsArray = control.controls;
  //   console.log('QUESTIONS ARRAY', questionsArray)

  //   if (questionsArray.length === 0) {
  //     return { noQuestions: true };
  //   }

  //   for (const questionControl of questionsArray) {
  //     const optionsArray = (questionControl as FormGroup).get(
  //       'options'
  //     ) as FormArray;

  //     console.log('OPTIONS ARRAY', optionsArray)

  //     if (optionsArray.length === 0) {
  //       return { noOptions: true };
  //     }

  //     const selectedOption = optionsArray.controls.find(
  //       (option) => option.get('is_correct_option')?.value
  //     );
  //     if (!selectedOption) {
  //       return { noSelectedOption: true };
  //     }

  //     console.log('SELECTED OPTION', selectedOption)
  //   }

  //   return null;
  // }

  // validateQuestions(control: FormArray): { [key: string]: boolean } | null {
  //   const questionsArray = control.controls;

    
  //   if (questionsArray.length === 0) {
  //     return { noQuestions: true };
  //   }
  
  //   for (const questionControl of questionsArray) {
  //     const optionsArray = (questionControl as FormGroup).get('options') as FormArray;
  
  //     if (optionsArray.length < 2) {
  //       return { insufficientOptions: true };
  //     }
  
  //     let filledOptions = 0;
  //     for (const optionControl of optionsArray.controls) {
  //       const optionText = optionControl.get('option_text')?.value;
  //       if (optionText && optionText.trim() !== '') {
  //         filledOptions++;
  //       }
  //     }
  
  //     if (filledOptions < 2) {
  //       return { insufficientOptions: true };
  //     }
  
  //     const selectedOptions = optionsArray.controls.filter(
  //       (option) => option.get('is_correct_option')?.value
  //     );
  
  //     if (selectedOptions.length === 0) {
  //       return { noSelectedOption: true };
  //     }
  //   }
  
  //   return null;
  // }

  validateQuestions(control: FormArray): { [key: string]: boolean } | null {
    const questionsArray = control.controls;

    if (questionsArray.length === 0) {
        return { noQuestions: true };
    }

    for (const questionControl of questionsArray) {
        const optionsArray = (questionControl as FormGroup).get('options') as FormArray;

        if (optionsArray.length < 2) {
            return { insufficientOptions: true };
        }

        let filledOptions = 0;
        let hasCorrectOption = false;

        for (const optionControl of optionsArray.controls) {
            const optionText = optionControl.get('option_text')?.value;
            const isCorrect = optionControl.get('is_correct_option')?.value;

            if (optionText && optionText.trim() !== '') {
                filledOptions++;
                if (isCorrect) {
                    hasCorrectOption = true;
                }
            }
        }

        if (filledOptions < 2) {
            return { insufficientOptions: true };
        }

        if (!hasCorrectOption) {
            return { noSelectedOption: true };
        }
    }

    return null;
}

  createManually() {
    this.createVisible = true;
    this.automaticVisible = false;
  }

  automaticManually() {
    this.createVisible = false;
    this.automaticVisible = true;
  }

  get questions(): FormArray {
    return this.questionForm.get('questions') as FormArray;
  }

  createQuestion(): FormGroup {
    return this.fb.group({
      question_id : null,
      question_text: [''],
      options: this.fb.array([
        this.createOption(),
        this.createOption(),
        this.createOption(),
        this.createOption(),
        this.createOption(),

      ]),
    });
  }

  createOption(): FormGroup {
    return this.fb.group({
      is_correct_option: [false],
      option_text: [''],
    });
  }

  addQuestion() {
    this.questions.push(this.createQuestion());
  }

  deleteQuestion(index: number) {
    this.questions.removeAt(index);
    this.questionForm.markAsTouched()
  }

  shouldShowSubmitButton(): boolean {
    return this.questions.length > 0;
  }

  aquestions() {
    const questionsArray = this.questionForm.get('questions') as FormArray;
    while (questionsArray.length !== 0) {
      questionsArray.removeAt(0);
    }
  }

  addChangeHandlerToOptions(questionGroup: FormGroup) {
    const optionsArray = questionGroup.get('options') as FormArray;

    optionsArray.controls.forEach((optionGroup, index) => {
      const checkbox = optionGroup.get('is_correct_option');

      if (checkbox) {
        checkbox.valueChanges.subscribe((isChecked: boolean) => {
          if (isChecked) {
            optionsArray.controls.forEach((otherOption, otherIndex) => {
              if (otherIndex !== index) {
                otherOption
                  .get('is_correct_option')
                  .setValue(false, { emitEvent: false });
              }
            });
          }
        });
      }
    });
  }

  submitCourse(): void {
    if (this.courseQuizChecked && !this.questionForm.valid) {
      this.createNotification(
        'error',
        '',
        'Empty value found!, please fill all the quiz details'
      );
      return;
    }

    this.isLoading = true;
    this.resetFilter();

    const persistCourse = async () => {
      try {
        const imagePath = await this.uploadCourseThumbnailIfNeeded();
        await this.deleteRemovedCourseThumbnailIfNeeded();

        let obj: any = {
          ...this.academyCourseForm.value,
          ...this.buildCourseQuizPayload(),
          image_path: imagePath,
        };

        obj.tag = this.sanitizeTagFormValues(obj.tag);
        obj.uploaded_date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        let timezone = obj.timezone ? obj.timezone : this.userCurrentTimezone.value;
        const localEndOfDay = momentTz
          .tz(obj.expires_date, timezone)
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
        obj.expires_date = localEndOfDay.utc().format('YYYY-MM-DD HH:mm:ss');

        this.webapi.requestJson('addCourse', obj).subscribe(
          (data) => {
            let response = JSON.parse(data.body);
            this.isLoading = false;
            this.Uploadprogress = 0;
            this.createNotification('success', '', response['message']);
            this.applyFilters();
            this.closeCourseAcademyForm();
          },
          () => {
            this.isLoading = false;
            this.Uploadprogress = 0;
            this.createNotification(
              'error',
              '',
              'Something went wrong, please try again!'
            );
          }
        );
      } catch (error) {
        this.isLoading = false;
        this.Uploadprogress = 0;
        this.createNotification(
          'error',
          '',
          'Failed to upload course thumbnail. Please try again.'
        );
      }
    };

    persistCourse();
  }

  getFileExtension(fileName: string): string {
    if (!fileName) {
      return '';
    }

    const trimmedFileName = fileName.trim();
    const lastDotIndex = trimmedFileName.lastIndexOf('.');
    if (lastDotIndex <= 0 || lastDotIndex === trimmedFileName.length - 1) {
      return '';
    }

    return trimmedFileName.substring(lastDotIndex + 1).toLowerCase();
  }

  onAttachmentFileNameBlur(attachment: ChapterAttachmentItem): void {
    // Display label only — does not change file_path / S3 key.
    const currentName = (attachment.file_name || '').trim();
    if (currentName) {
      attachment.file_name = currentName;
      return;
    }

    attachment.file_name =
      attachment.file?.name ||
      attachment.file_path ||
      'attachment';
  }

  getAttachmentFileType(file: File): string {
    if (file.type) {
      return file.type;
    }

    return this.getAttachmentFileTypeFromName(file.name);
  }

  getAttachmentFileTypeFromName(fileName: string): string {
    const extension = this.getFileExtension(fileName);

    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      case 'mp4':
        return 'video/mp4';
      case 'mov':
        return 'video/quicktime';
      default:
        return 'application/octet-stream';
    }
  }

  getAttachmentFileTypeLabel(fileType: string): string {
    if (!fileType) {
      return '-';
    }

    if (fileType.includes('pdf')) {
      return 'PDF';
    }

    if (fileType.startsWith('image/')) {
      return 'Image';
    }

    if (fileType.startsWith('video/')) {
      return 'Video';
    }

    return fileType;
  }

  getAttachmentFileTypeIcon(fileType: string): string {
    if (!fileType) {
      return 'file';
    }

    if (fileType.includes('pdf')) {
      return 'file-pdf';
    }

    if (fileType.startsWith('image/')) {
      return 'file-image';
    }

    if (fileType.startsWith('video/')) {
      return 'video-camera';
    }

    return 'file';
  }

  isVideoAttachment(attachment: ChapterAttachmentItem): boolean {
    const fileType =
      attachment?.file_type ||
      this.getAttachmentFileTypeFromName(
        attachment?.file?.name || attachment?.file_name || attachment?.file_path || ''
      );

    return !!fileType && fileType.startsWith('video/');
  }

  isPdfAttachment(attachment: ChapterAttachmentItem): boolean {
    const fileType =
      attachment?.file_type ||
      this.getAttachmentFileTypeFromName(
        attachment?.file?.name || attachment?.file_name || attachment?.file_path || ''
      );

    return !!fileType && fileType.includes('pdf');
  }

  isAllowedAttachmentFile(file: File): boolean {
    const fileType = file.type.split('/')[0];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    return (
      (fileType === 'image' &&
        ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) ||
      (fileType === 'application' && ['pdf'].includes(fileExtension)) ||
      (fileType === 'video' && ['mp4', 'mov'].includes(fileExtension))
    );
  }

  private createTempAttachmentId(): string {
    return `temp-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  private normalizeDisplayPosition(value: any): number {
    if (value === 'above' || value === 0 || value === '0') {
      return 0;
    }
    return 1;
  }

  private normalizeAttachmentOrder(): void {
    this.chapterAttachments.forEach((attachment, index) => {
      attachment.attachment_order = index;
    });
  }

  getActiveChapterAttachments(): ChapterAttachmentItem[] {
    return [...this.chapterAttachments].sort(
      (a, b) => a.attachment_order - b.attachment_order
    );
  }

  addChapterAttachmentFiles(files: FileList | File[]): void {
    const fileArray = Array.from(files as File[]);

    fileArray.forEach(async (file) => {
      if (!this.isAllowedAttachmentFile(file)) {
        this.showAlert(
          'Invalid file format detected.',
          'Only PDF, image, MP4, and MOV files are supported. Please upload a valid file format.'
        );
        return;
      }

      const fileType = this.getAttachmentFileType(file);
      const isVideo = fileType.startsWith('video/');
      const isPdf = fileType.includes('pdf');
      let durationSeconds: number | null = null;

      if (isVideo) {
        try {
          durationSeconds = await this.readVideoDurationSeconds(file);
        } catch (error) {
          console.log('Unable to read video duration', error);
          durationSeconds = null;
        }
      } else if (isPdf) {
        try {
          durationSeconds = await this.readPdfEstimatedDurationSeconds(file);
        } catch (error) {
          console.log('Unable to estimate PDF read time', error);
          durationSeconds = PDF_READ_SECONDS_DEFAULT;
        }
      }

      this.chapterAttachments.push({
        tempId: this.createTempAttachmentId(),
        file,
        file_name: file.name,
        file_type: fileType,
        fileUrl: URL.createObjectURL(file),
        attachment_order: this.chapterAttachments.length,
        display_position: 1,
        is_skippable: false,
        duration_seconds: durationSeconds,
        isNew: true,
      });

      this.normalizeAttachmentOrder();
      this.validateForm();
      this.cdr.detectChanges();
    });
  }

  /** Read media duration from a local video File (seconds, rounded). */
  private readVideoDurationSeconds(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const objectUrl = URL.createObjectURL(file);
      const video = document.createElement('video');
      video.preload = 'metadata';

      const cleanup = () => {
        URL.revokeObjectURL(objectUrl);
        video.removeAttribute('src');
        video.load();
      };

      video.onloadedmetadata = () => {
        const duration = Number(video.duration);
        cleanup();
        if (!Number.isFinite(duration) || duration <= 0) {
          reject(new Error('Invalid video duration'));
          return;
        }
        resolve(Math.round(duration));
      };

      video.onerror = () => {
        cleanup();
        reject(new Error('Failed to load video metadata'));
      };

      video.src = objectUrl;
    });
  }

  /**
   * Estimate PDF read time from page count (pdf.js).
   * ~90s per page, minimum 1 minute.
   */
  private async readPdfEstimatedDurationSeconds(file: File): Promise<number> {
    const buffer = await file.arrayBuffer();
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'assets/pdf/pdf.worker.min.js';
    const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;
    const pages = Number(pdf?.numPages) || 0;
    if (pages <= 0) {
      return PDF_READ_SECONDS_DEFAULT;
    }
    return Math.max(60, Math.round(pages * PDF_READ_SECONDS_PER_PAGE));
  }

  onAttachmentFilesRejected(): void {
    this.showAlert(
      'Invalid file format detected.',
      'Only PDF, image, MP4, and MOV files are supported. Please upload a valid file format.'
    );
  }

  removeChapterAttachment(attachment: ChapterAttachmentItem): void {
    if (attachment.file_path && !attachment.isNew) {
      this.removedAttachmentPaths.push(attachment.file_path);
    }

    this.revokeAttachmentPreviewUrl(attachment);
    this.chapterAttachments = this.chapterAttachments.filter(
      (item) => item.tempId !== attachment.tempId
    );
    this.normalizeAttachmentOrder();
    this.validateForm();
  }

  moveChapterAttachmentUp(index: number): void {
    if (index <= 0) {
      return;
    }

    const attachments = this.getActiveChapterAttachments();
    [attachments[index - 1], attachments[index]] = [
      attachments[index],
      attachments[index - 1],
    ];
    this.chapterAttachments = attachments;
    this.normalizeAttachmentOrder();
  }

  moveChapterAttachmentDown(index: number): void {
    const attachments = this.getActiveChapterAttachments();
    if (index >= attachments.length - 1) {
      return;
    }

    [attachments[index], attachments[index + 1]] = [
      attachments[index + 1],
      attachments[index],
    ];
    this.chapterAttachments = attachments;
    this.normalizeAttachmentOrder();
  }

  resetChapterAttachments(): void {
    this.chapterAttachments.forEach((attachment) =>
      this.revokeAttachmentPreviewUrl(attachment)
    );
    this.chapterAttachments = [];
    this.removedAttachmentPaths = [];
    this.fileList = undefined;
    this.uploadedFileUrl = undefined;
    this.uploadedFileName = undefined;
  }

  getAttachmentPreviewUrl(attachment: ChapterAttachmentItem): string | null {
    if (attachment?.fileUrl) {
      return attachment.fileUrl;
    }

    if (attachment?.file) {
      attachment.fileUrl = URL.createObjectURL(attachment.file);
      return attachment.fileUrl;
    }

    if (attachment?.file_path) {
      return environment.BUCKET_URL + attachment.file_path;
    }

    return null;
  }

  canPreviewAttachment(attachment: ChapterAttachmentItem): boolean {
    return !!(attachment?.fileUrl || attachment?.file || attachment?.file_path);
  }

  previewAttachment(event: Event, attachment: ChapterAttachmentItem): void {
    event.preventDefault();
    event.stopPropagation();

    const previewUrl = this.getAttachmentPreviewUrl(attachment);
    if (!previewUrl) {
      return;
    }

    // Open via a temporary anchor so blob: URLs are not stripped by Angular's href sanitizer.
    const link = document.createElement('a');
    link.href = previewUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private revokeAttachmentPreviewUrl(attachment: ChapterAttachmentItem): void {
    if (attachment?.fileUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(attachment.fileUrl);
      attachment.fileUrl = undefined;
    }
  }

  loadChapterAttachmentsFromData(data: any): void {
    this.resetChapterAttachments();

    if (data.attachments?.length) {
      this.chapterAttachments = data.attachments.map(
        (attachment: any, index: number) => ({
          tempId: this.createTempAttachmentId(),
          chapter_attachment_relation_id:
            attachment.chapter_attachment_relation_id ||
            attachment.chapter_attachment_id,
          file_name: attachment.file_name || attachment.upload_name,
          file_path: attachment.file_path,
          file_type:
            attachment.file_type ||
            this.getAttachmentFileTypeFromName(
              attachment.file_name || attachment.upload_name || ''
            ),
          fileUrl: attachment.file_path
            ? environment.BUCKET_URL + attachment.file_path
            : undefined,
          attachment_order:
            attachment.attachment_order !== undefined
              ? attachment.attachment_order
              : attachment.content_order !== undefined
              ? attachment.content_order
              : index,
          display_position: this.normalizeDisplayPosition(
            attachment.display_position
          ),
          is_skippable:
            (attachment.file_type ||
              this.getAttachmentFileTypeFromName(
                attachment.file_name || attachment.upload_name || ''
              )
            ).startsWith('video/') && !!attachment.is_skippable,
          duration_seconds:
            attachment.duration_seconds !== undefined &&
            attachment.duration_seconds !== null
              ? Number(attachment.duration_seconds)
              : null,
          isNew: false,
        })
      );
      return;
    }

    if (data.chapter_path) {
      this.chapterAttachments = [
        {
          tempId: this.createTempAttachmentId(),
          file_name: data.chapter_upload_name,
          file_path: data.chapter_path,
          file_type: this.getAttachmentFileTypeFromName(
            data.chapter_upload_name || data.chapter_path || ''
          ),
          fileUrl: environment.BUCKET_URL + data.chapter_path,
          attachment_order: 0,
          display_position: 1,
          is_skippable: false,
          isNew: false,
        },
      ];
    }
  }

  onChapterContentEditorCreated(quill: Quill): void {
    this.chapterContentQuill = quill;
    this.attachChapterCustomColorPicker(quill);
  }

  /**
   * Adds a native color input next to Quill's palette so authors can pick any hex.
   */
  private attachChapterCustomColorPicker(quill: Quill): void {
    const toolbarModule = quill.getModule('toolbar') as { container?: HTMLElement };
    const toolbarEl = toolbarModule?.container;
    if (!toolbarEl || toolbarEl.querySelector('.chapter-custom-color-picker')) {
      return;
    }

    const wrap = document.createElement('span');
    wrap.className = 'chapter-custom-color-wrap';
    wrap.setAttribute('title', 'Custom text color');

    const swatch = document.createElement('span');
    swatch.className = 'chapter-custom-color-swatch';
    swatch.textContent = 'A';

    const input = document.createElement('input');
    input.type = 'color';
    input.value = '#e60000';
    input.className = 'chapter-custom-color-picker';
    input.setAttribute('title', 'Pick any text color');
    input.setAttribute('aria-label', 'Custom text color');

    const applyColor = (raw: string) => {
      const color = (raw || '#000000').toLowerCase();
      const normalized =
        color === '#000000' || color === '#000' ? '#000000' : color;
      quill.focus();
      quill.format('color', normalized);
      swatch.style.color = normalized;
      swatch.style.borderBottomColor = normalized;
    };

    input.addEventListener('input', () => applyColor(input.value));
    input.addEventListener('change', () => applyColor(input.value));

    wrap.appendChild(swatch);
    wrap.appendChild(input);

    const colorButton = toolbarEl.querySelector('.ql-color');
    const colorFormats = colorButton?.closest('.ql-formats');
    if (colorFormats) {
      colorFormats.appendChild(wrap);
    } else {
      toolbarEl.appendChild(wrap);
    }
  }

  /** HTML currently in the chapter Quill editor (includes inline color styles). */
  private getChapterContentHtmlFromEditor(): string | null {
    if (!this.chapterContentQuill?.root) {
      return null;
    }
    let html = this.chapterContentQuill.root.innerHTML || '';
    if (html === '<p><br></p>' || html === '<div><br></div>') {
      html = '';
    }
    return html;
  }

  private buildChapterPayloadBase(): any {
    const isSwitchOn = this.activeForm.get('is_active').value;
    const obj = {
      course_id: this.selectedCourseId,
      ...this.academyChapterForm.value,
    };

    delete obj.File;
    obj.is_active = isSwitchOn;
    obj.tag = this.sanitizeTagFormValues(obj.tag);

    // ngx-quill can lag the form control when only formats (color) change.
    // Always take HTML from the live editor so colors are not dropped on Save.
    const editorHtml = this.getChapterContentHtmlFromEditor();
    if (editorHtml != null) {
      obj.content = editorHtml;
    }
    if (typeof obj.content === 'string') {
      obj.content = normalizeQuillColorHtml(obj.content);
    }

    if (this.checkboxChecked) {
      const nonEmptyQuestionData = this.questionForm.value;

      if (
        nonEmptyQuestionData.questions &&
        Array.isArray(nonEmptyQuestionData.questions)
      ) {
        const result = nonEmptyQuestionData.questions
          .filter(
            (question: any) =>
              question?.question_text && question.question_text.trim() !== ''
          )
          .map((question: any) => ({
            ...question,
            options: question.options.filter(
              (option: any) =>
                option.option_text && option.option_text.trim() !== ''
            ),
          }));

        Object.assign(obj, {
          questions: result,
          quiz_name: nonEmptyQuestionData.quiz_name,
        });
      }
    }

    return obj;
  }

  private serializeAttachmentsForApi(
    attachments: ChapterAttachmentItem[]
  ): any[] {
    return attachments.map((attachment, index) => ({
      chapter_attachment_relation_id: attachment.chapter_attachment_relation_id,
      // Editable display label only
      file_name: (attachment.file_name || '').trim() || attachment.file?.name,
      // Actual S3 object key — never derived from the edited label
      file_path: attachment.file_path,
      file_type:
        attachment.file_type ||
        this.getAttachmentFileTypeFromName(
          attachment.file?.name || attachment.file_path || attachment.file_name
        ),
      attachment_order: index,
      display_position: this.normalizeDisplayPosition(attachment.display_position),
      is_skippable: this.isVideoAttachment(attachment)
        ? !!attachment.is_skippable
        : false,
      duration_seconds:
        this.isVideoAttachment(attachment) || this.isPdfAttachment(attachment)
          ? attachment.duration_seconds ?? null
          : null,
    }));
  }

  private async uploadNewChapterAttachments(
    attachments: ChapterAttachmentItem[]
  ): Promise<ChapterAttachmentItem[]> {
    const uploadedAttachments: ChapterAttachmentItem[] = [];

    for (let index = 0; index < attachments.length; index++) {
      const attachment = attachments[index];

      if (attachment.isNew && attachment.file) {
        const unixTimestamp = Date.now() + index;
        // Always use the original File object's name for the storage key
        // so renaming the display label cannot break the S3 path/extension.
        const fileExtension = this.getFileExtension(attachment.file.name);
        const combinedFileName = fileExtension
          ? `${unixTimestamp}.${fileExtension}`
          : `${unixTimestamp}`;

        await this.awsService.uploadFile(
          attachment.file,
          combinedFileName,
          (progress) => {
            this.Uploadprogress = progress;
          }
        );

        this.revokeAttachmentPreviewUrl(attachment);
        uploadedAttachments.push({
          ...attachment,
          file_path: combinedFileName,
          fileUrl: environment.BUCKET_URL + combinedFileName,
          isNew: false,
        });
      } else {
        uploadedAttachments.push(attachment);
      }
    }

    return uploadedAttachments;
  }

  private async deleteRemovedAttachmentFiles(): Promise<void> {
    const uniquePaths = [...new Set(this.removedAttachmentPaths)];

    for (const filePath of uniquePaths) {
      await this.awsService.deleteSingleFile(filePath);
    }

    this.removedAttachmentPaths = [];
  }

  private hasNewAttachmentFiles(attachments: ChapterAttachmentItem[]): boolean {
    return attachments.some((attachment) => attachment.isNew && attachment.file);
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    this.addChapterAttachmentFiles([file as unknown as File]);
    return false;
  };

  validateForm(): void {
    Object.keys(this.academyChapterForm.controls).forEach((key) => {
      this.academyChapterForm.get(key)?.updateValueAndValidity();
    });
  }

  submitAcademyChapter(): void {
    this.isLoading = true;
    this.resetFilter();

    const attachments = this.getActiveChapterAttachments();

    if (this.hasNewAttachmentFiles(attachments)) {
      this.uploadNewChapterAttachments(attachments)
        .then((uploadedAttachments) => {
          const obj = this.buildChapterPayloadBase();
          if (uploadedAttachments.length > 0) {
            obj.attachments =
              this.serializeAttachmentsForApi(uploadedAttachments);
          }
          this.webapi.requestJson('addChapter', obj).subscribe(
            (data) => {
              const response = JSON.parse(data.body);
              this.isLoading = false;
              this.Uploadprogress = 0;
              this.closeAcademyForm();
              this.createNotification('success', '', response['message']);
              this.getCourseList({ filters: [] }, this.selectedCourseId);
            },
            () => {
              this.isLoading = false;
              this.Uploadprogress = 0;
            }
          );
        })
        .catch(() => {
          this.isLoading = false;
          this.Uploadprogress = 0;
          this.createNotification(
            'error',
            '',
            'Something went wrong, please try again!'
          );
        });
      return;
    }

    this.finalAddChapter(attachments);
  }

  finalAddChapter(attachments: ChapterAttachmentItem[] = []) {
    const obj = this.buildChapterPayloadBase();
    if (attachments.length > 0) {
      obj.attachments = this.serializeAttachmentsForApi(attachments);
    }

    this.webapi.requestJson('addChapter', obj).subscribe(
      (data) => {
        const response = JSON.parse(data.body);
        this.isLoading = false;
        this.closeAcademyForm();
        this.createNotification('success', '', response['message']);
        this.getCourseList({ filters: [] }, this.selectedCourseId);
      },
      () => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'Something went wrong, please try again!'
        );
      }
    );
  }

  openAcademyForm(): void {
    this.resetChapterAttachments();
    this.updateModes = false;
    this.academyChapterForm.reset();
    this.questionForm.reset();
    this.activeForm.get('is_active').setValue(true);
    this.checkboxDisabled = false;
    this.academyFormVisible = true;
    this.detailVisible = false;
    this.aquestions();
    this.addQuestion();
  }

  openAcademyCourseForm() {
    this.resetAcademyCourseForm();
    this.academyCourseFormVisible = true;
    this.academyCourseForm.reset();
    this.academyCourseForm.get('timezone').setValue(this.userCurrentTimezone.value);
    this.detailVisible = false;
    this.courseQuizChecked = false;
    this.courseQuizDisabled = false;
    this.questionForm.reset();
    this.aquestions();
    this.addQuestion();
  }

  resetAcademyCourseForm(): void {
    this.academyCourseForm.reset();
    this.updateMode = false;
    this.updateCourseId = undefined;
    this.rawUpdateData = {};
    this.originalFormValue = this.academyCourseForm.value; //latest
    this.courseQuizChecked = false;
    this.courseQuizDisabled = false;
    this.clearCourseThumbnailState();
  }

  resetAcademyUpdateForm(): void {
    this.academyCourseForm.patchValue(this.rawUpdateData);
    this.academyCourseForm.controls.tag.setValue(
      this.getValidTagIds(this.rawUpdateData.tag)
    );
    this.loadCourseQuizFromData(this.rawUpdateData);
  }

  fillAcademyCourseForm(data: any): void {
    this.openAcademyCourseForm();
    const tagIds = this.getValidTagIds(data.tag);

    this.academyCourseForm.patchValue({
      course_name: data.course_name,
      uploaded_date: data.uploaded_date,
      expires_date: data.expires_date,
      category_id: data.category_id,
      timezone:data.timezone,
      send_notification: data.send_notification ? 1 : 0,
      notification_recurrence:
        data.notification_recurrence === 0 || data.notification_recurrence
          ? data.notification_recurrence
          : 2,
      image_path: data.image_path || null,
    });

    this.courseThumbnailFile = null;
    this.courseThumbnailPathToDelete = null;
    this.courseThumbnailPreviewUrl = this.getCourseThumbnailPreviewUrl(
      data.image_path
    );

    this.academyCourseForm.controls.tag.setValue(tagIds);
    this.updateMode = true;
    this.updateCourseId = data.course_id;
    this.rawUpdateData = { ...data };
    this.originalFormValue = this.academyCourseForm.value; //latest
    this.loadCourseQuizFromData(data);
  }

  private loadCourseQuizFromData(data: any): void {
    this.aquestions();
    const quizzes = data?.quizzes || [];

    if (quizzes.length > 0) {
      this.courseQuizChecked = true;
      this.courseQuizDisabled = true;

      const quiz = quizzes[0];
      this.questionForm.get('quiz_name').setValue(quiz.quiz_name);

      (quiz.questions || []).forEach((question) => {
        const questionGroup = this.fb.group({
          question_text: question.question_text,
          options: this.fb.array([]),
          question_id: question.question_id ? question.question_id : null,
        });

        (question.options || []).forEach((option) => {
          const optionGroup = this.fb.group({
            is_correct_option: option.is_correct_option === 1,
            option_text: option.option_text,
            option_id: option.option_id ? option.option_id : null,
          });

          (questionGroup.get('options') as FormArray).push(optionGroup);
        });

        this.questions.push(questionGroup);
        this.addChangeHandlerToOptions(questionGroup);
      });
      return;
    }

    this.courseQuizChecked = false;
    this.courseQuizDisabled = false;
    this.addQuestion();
  }

  private buildCourseQuizPayload(): any {
    if (!this.courseQuizChecked) {
      return {};
    }

    const nonEmptyQuestionData = this.questionForm.value;
    if (
      !nonEmptyQuestionData.questions ||
      !Array.isArray(nonEmptyQuestionData.questions)
    ) {
      return {
        quiz_name: nonEmptyQuestionData.quiz_name,
        questions: [],
      };
    }

    const result = nonEmptyQuestionData.questions
      .filter(
        (question: any) =>
          question?.question_text && question.question_text.trim() !== ''
      )
      .map((question: any) => ({
        ...question,
        options: question.options.filter(
          (option: any) =>
            option.option_text && option.option_text.trim() !== ''
        ),
      }));

    return {
      quiz_name: nonEmptyQuestionData.quiz_name,
      questions: result,
    };
  }

  onCourseQuizCheckboxChange(event: any): void {
    this.courseQuizChecked = event.target.checked;
    if (!this.courseQuizChecked) {
      this.questionForm.reset();
      this.aquestions();
      this.addQuestion();
    }
  }

  onSendNotificationChange(value: number): void {
    if (value !== 1) {
      this.academyCourseForm.get('notification_recurrence')?.setValue(null);
      return;
    }

    if (!this.academyCourseForm.get('notification_recurrence')?.value &&
        this.academyCourseForm.get('notification_recurrence')?.value !== 0) {
      this.academyCourseForm.get('notification_recurrence')?.setValue(2);
    }
  }

  openCourseQuizFromDetail(): void {
    if (!this.selectedCourseRaw) {
      return;
    }
    this.fillAcademyCourseForm(this.selectedCourseRaw);
  }

  fillAcademyChapterForm(data: any): void {
    this.openAcademyForm();
    if (data.quizzes.length > 0) {
      this.checkboxChecked = true;
      this.checkboxDisabled = true;
    } else {
      this.checkboxChecked = false;
      this.checkboxDisabled = false;
    }
    const tagIds = this.getValidTagIds(data.tag);

    this.academyChapterForm.patchValue({
      chapter_name: data.chapter_name,
      description: data.description,
      content: data.content,
    });

    this.activeForm.patchValue({
      is_active: data.is_active,
    });

    this.academyChapterForm.controls.tag.setValue(tagIds);

    this.loadChapterAttachmentsFromData(data);

    this.aquestions();

    data.quizzes.forEach((quiz) => {
      this.questionForm.get('quiz_name').setValue(quiz.quiz_name);

      quiz.questions.forEach((question) => {
        const questionGroup = this.fb.group({
          question_text: question.question_text,
          options: this.fb.array([]),
          question_id: question.question_id ? question.question_id : null,
        });

        question.options.forEach((option) => {
          const optionGroup = this.fb.group({
            is_correct_option: option.is_correct_option === 1,
            option_text: option.option_text,
            option_id: option.option_id ? option.option_id : null,
          });

          (questionGroup.get('options') as FormArray).push(optionGroup);
        });

        this.questions.push(questionGroup);
        console.log('This is question', this.questions);
        this.addChangeHandlerToOptions(questionGroup);
      });
    });

    this.updateModes = true;
    this.updateChapterId = data.chapter_id;
    console.log('updated chapterid', this.updateChapterId);
    this.rawUpdateDatas = { ...data };
  }

  updateAcademyCourse(): void {
    if (this.courseQuizChecked && !this.questionForm.valid) {
      this.createNotification(
        'error',
        '',
        'Empty value found!, please fill all the quiz details'
      );
      return;
    }

    this.isLoading = true;

    const persistCourse = async () => {
      try {
        const imagePath = await this.uploadCourseThumbnailIfNeeded();
        await this.deleteRemovedCourseThumbnailIfNeeded();

        let updateObj: any = {
          course_id: this.updateCourseId,
          ...this.academyCourseForm.value,
          ...this.buildCourseQuizPayload(),
          image_path: imagePath,
        };

        updateObj.tag = this.sanitizeTagFormValues(updateObj.tag);
        updateObj.uploaded_date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        let timezone = updateObj.timezone
          ? updateObj.timezone
          : this.userCurrentTimezone.value;
        const localEndOfDay = momentTz
          .tz(updateObj.expires_date, timezone)
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
        updateObj.expires_date = localEndOfDay;

        this.webapi.requestJson('updateCourse', updateObj).subscribe(
          (data) => {
            var response = JSON.parse(data.body);
            this.isLoading = false;
            this.Uploadprogress = 0;
            this.createNotification('success', '', response['message']);
            this.getCourseList({ filters: [] });
            this.closeCourseAcademyForm();
          },
          () => {
            this.isLoading = false;
            this.Uploadprogress = 0;
            this.createNotification(
              'error',
              '',
              'An error occurred. Please try again later.'
            );
          }
        );
      } catch (error) {
        this.isLoading = false;
        this.Uploadprogress = 0;
        this.createNotification(
          'error',
          '',
          'Failed to upload course thumbnail. Please try again.'
        );
      }
    };

    persistCourse();
  }

  // updateAcademyChapter(): void {
  //   let updateObj = {
  //     course_id: this.selectedCourseId,
  //     chapter_id: this.updateChapterId,
  //     ...this.academyChapterForm.value,
  //     ...this.questionForm.value,
  //   };
  //   this.webapi.requestJson('updateChapter', updateObj).subscribe(
  //     (data) => {
  //       var response = JSON.parse(data.body);
  //       this.courseData = [...response.data];
  //       this.closeAcademyForm();
  //     },
  //     (error) => {}
  //   );
  // }

  updateAcademyChapter(): void {
    if (this.checkboxChecked && !this.questionForm.valid) {
      this.createNotification(
        'error',
        '',
        'Empty value found!, please fill all the details'
      );
      return;
    }

    this.isLoading = true;
    const attachments = this.getActiveChapterAttachments();

    const submitUpdate = (uploadedAttachments: ChapterAttachmentItem[]) => {
      const updateObj = {
        ...this.buildChapterPayloadBase(),
        chapter_id: this.updateChapterId,
        ...this.activeForm.value,
        attachments: this.serializeAttachmentsForApi(uploadedAttachments),
      };

      this.webapi.requestJson('updateChapter', updateObj).subscribe(
        (data) => {
          const response = JSON.parse(data.body);
          this.isLoading = false;
          this.Uploadprogress = 0;
          this.createNotification('success', '', response['message']);
          this.getCourseList({ filters: [] });
          this.closeAcademyForm();
        },
        () => {
          this.isLoading = false;
          this.Uploadprogress = 0;
          this.createNotification(
            'error',
            '',
            'Something went wrong, please try again!'
          );
        }
      );
    };

    this.deleteRemovedAttachmentFiles()
      .then(() => {
        if (this.hasNewAttachmentFiles(attachments)) {
          return this.uploadNewChapterAttachments(attachments).then(
            submitUpdate
          );
        }

        submitUpdate(attachments);
      })
      .catch(() => {
        this.isLoading = false;
        this.Uploadprogress = 0;
        this.createNotification(
          'error',
          '',
          'Something went wrong, please try again!'
        );
      });
  }

  finalUpdate(fileKey?) {
    if (fileKey) {
      this.removedAttachmentPaths.push(fileKey);
    }

    this.updateAcademyChapter();
  }

  displayChapters(item) {
    this.showLoad = true;
    this.detailVisible = true;
    this.selectedCourseId = item;

    var selectedCourse = this.courseData.find((course) => {
      return course.course_id === this.selectedCourseId;
    });

    this.selectedCourseRaw = selectedCourse;

    this.selectedCourseChapters = selectedCourse.chapters.map((chapter) => {
      return {
        ...chapter,
        course_id: selectedCourse.course_id,
      };
    });
    this.selectedCourseChaptersRaw = this.selectedCourseChapters;
    this.showLoad = false;
    //For Hide the Delete icon after deleting the chapter && when no checkbox is checked
    this.anyCheckedChapter = this.selectedCourseChapters.some((e) => e.checked);
    console.log('this is chapter', this.selectedCourseChapters);
  }

  // refreshStatus(): void {
  //   this.checkedDataCourse = [];
  //   this.courseData.forEach((element) => {
  //     if (element.checked) {
  //       this.checkedDataCourse.push(element.course_id);
  //       if (element.chapters && element.chapters.length > 0) {
  //         element.chapters.forEach((chapter) => {
  //           chapter.checked = true;

  //           // if (chapter.quizzes && chapter.quizzes.length > 0) {
  //           //   chapter.quizzes.forEach((quiz) => {
  //           //     quiz.checked = true;
  //           //   });
  //           // }
  //         });
  //       }
  //     } else {
  //       if (element.chapters && element.chapters.length > 0) {
  //         element.chapters.forEach((chapter) => {
  //           chapter.checked = false;

  //           if (chapter.quizzes && chapter.quizzes.length > 0) {
  //             chapter.quizzes.forEach((quiz) => {
  //               quiz.checked = false;
  //             });
  //           }
  //         });
  //       }
  //     }
  //   });

  //   this.anyChecked = this.courseData.some((e) => e.checked);
  //   this.allChecked = this.courseData.every((e) => e.checked);
  // }

  checkAll(value: boolean): void {
    this.courseData.forEach((course) => {
      course.checked = value;
      if (course.chapters && course.chapters.length > 0) {
        course.chapters.forEach((chapter) => {
          chapter.checked = value;
        });
      }
    });
    this.refreshStatus();
  }

  checkAllChapter(value: boolean): void {
    this.selectedCourseChapters.forEach((data) => {
      data.checked = value;
    });
    this.refreshChapterStatus();
  }

  refreshStatus(): void {
    this.checkedDataCourse = [];
    this.courseData.forEach((element) => {
      if (element.checked) {
        element.indeterminate = false;
        this.checkedDataCourse.push(element.course_id);
        if (element.chapters && element.chapters.length > 0) {
          element.chapters.forEach((chapter) => {
            chapter.checked = true;

            // if (chapter.quizzes && chapter.quizzes.length > 0) {
            //   chapter.quizzes.forEach((quiz) => {
            //     quiz.checked = true;
            //   });
            // }
          });
        }
      } else {
        if (element.chapters && element.chapters.length > 0) {
          element.chapters.forEach((chapter) => {
            chapter.checked = false;

            if (chapter.quizzes && chapter.quizzes.length > 0) {
              chapter.quizzes.forEach((quiz) => {
                quiz.checked = false;
              });
            }
          });
        }
      }
    });

    this.anyChecked = this.courseData.some((e) => e.checked);
    this.allChecked = this.courseData.every((e) => e.checked);
  }

  // refreshChapterStatus(): void {
  //   this.checkedData = [];
  //   this.checkedDataCourse = [];
  //   let courseIdsWithCheckedChapters = new Set();

  //   this.selectedCourseChapters.forEach((element) => {
  //       if (element.checked) {
  //           this.checkedData.push(element.chapter_id);
  //           courseIdsWithCheckedChapters.add(element.course_id);
  //       }
  //   });

  //   this.courseData.forEach(course => {
  //       let anyChapterChecked = this.selectedCourseChapters.some(chapter => chapter.course_id === course.course_id && chapter.checked);
  //       let anyChapterUnchecked = this.selectedCourseChapters.some(chapter => chapter.course_id === course.course_id && !chapter.checked);

  //       if (anyChapterChecked && anyChapterUnchecked) {
  //           course.indeterminate = true;
  //           course.checked = false;
  //       } else if (anyChapterChecked) {
  //           course.indeterminate = false;
  //           course.checked = true;
  //       } else {
  //           course.indeterminate = false;
  //           course.checked = false;
  //       }

  //       course.chapters.forEach(chapter => {
  //           if (this.checkedData.includes(chapter.chapter_id)) {
  //               chapter.checked = true;
  //           } else {
  //               chapter.checked = false;
  //           }
  //       });
  //   });

  //   this.checkedDataCourse = Array.from(courseIdsWithCheckedChapters);

  //   this.selectedCourseChaptersArray = this.selectedCourseChapters;
  //   this.anyCheckedChapter = this.selectedCourseChapters.some((e) => e.checked);
  //   this.allCheckedChapter = this.selectedCourseChapters.every((e) => e.checked);
  // }

  // refreshChapterStatus(): void {
  //   this.checkedData = [];
  //   this.checkedDataCourse = [];

  //   this.selectedCourseChapters.forEach((element) => {
  //       this.currentSelectedCourseId = element.course_id;
  //       if (element.checked) {
  //           this.checkedData.push(element.chapter_id);
  //       }
  //   });

  //   this.courseData.forEach(course => {
  //       let courseChecked = course.chapters.every(chapter => chapter.checked);
  //       let courseIndeterminate = course.chapters.some(chapter => chapter.indeterminate);

  //       if (courseChecked) {
  //           this.checkedDataCourse.push(course.course_id);
  //       } else if (courseIndeterminate) {

  //       }

  //       course.chapters.forEach(chapter => {
  //           if (this.checkedData.includes(chapter.chapter_id)) {
  //               chapter.checked = true;
  //           } else {
  //               chapter.checked = false;
  //           }
  //       });
  //   });

  //   let index = this.courseData.findIndex(element => {
  //       if (element.course_id === this.currentSelectedCourseId) {
  //           return true;
  //       }
  //   });

  //   if (this.checkedData.length > 0 && this.checkedData.length !== this.selectedCourseChapters.length) {
  //       if (index != null)
  //           this.courseData[index].indeterminate = true;
  //       this.courseData[index].checked = false;
  //   } else {
  //       this.courseData[index].indeterminate = false;
  //   }

  //   this.courseData.forEach(course => {
  //       if (course.checked) {
  //           if (!this.checkedDataCourse.includes(course.course_id)) {
  //               this.checkedDataCourse.push(course.course_id);
  //           }
  //       } else {
  //           let index = this.checkedDataCourse.indexOf(course.course_id);
  //           if (index !== -1) {
  //               this.checkedDataCourse.splice(index, 1);
  //           }
  //       }
  //   });
  // }

  refreshChapterStatus(): void {
    this.checkedData = [];
    this.checkedDataCourse = [];
    let courseIdsWithCheckedChapters = new Set();

    this.selectedCourseChapters.forEach((element) => {
      if (element.checked) {
        this.checkedData.push(element.chapter_id);
        courseIdsWithCheckedChapters.add(element.course_id);
      }
    });

    this.courseData.forEach((course) => {
      let anyChapterChecked = this.selectedCourseChapters.some(
        (chapter) => chapter.course_id === course.course_id && chapter.checked
      );
      let anyChapterUnchecked = this.selectedCourseChapters.some(
        (chapter) => chapter.course_id === course.course_id && !chapter.checked
      );

      if (anyChapterChecked && anyChapterUnchecked) {
        course.indeterminate = true;
        course.checked = false;
      } else if (anyChapterChecked) {
        course.indeterminate = false;
        course.checked = true;
      } else {
        course.indeterminate = false;
        course.checked = false;
      }

      course.chapters.forEach((chapter) => {
        if (this.checkedData.includes(chapter.chapter_id)) {
          chapter.checked = true;
        } else {
          chapter.checked = false;
        }
      });
    });

    this.checkedDataCourse = Array.from(courseIdsWithCheckedChapters);

    this.selectedCourseChaptersArray = this.selectedCourseChapters;
    this.anyCheckedChapter = this.selectedCourseChapters.some((e) => e.checked);
    this.allCheckedChapter = this.selectedCourseChapters.every(
      (e) => e.checked
    );
  }

  createChapterObject(chapterData: any): any {
    const chapterObj = {
      course_id: chapterData.course_id,
      chapter_id: [chapterData.chapter_id],
      quiz_id: [],
      question_id: [],
    };

    if (chapterData.quizzes && chapterData.quizzes.length > 0) {
      for (const chapter of chapterData.quizzes) {
        chapterObj.quiz_id.push(chapter.quiz_id);

        if (chapter.questions && chapter.questions.length > 0) {
          for (const question of chapter.questions) {
            chapterObj.question_id.push(question.question_id);
          }
        }
      }
    }

    return chapterObj;
  }

  onKeyUp(query: string): void {
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.courseDataRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag) => {
          if (tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.course_name && d.course_name.toLowerCase().includes(q)) ||
          (d.chapter_count &&
            d.chapter_count.toString().toLowerCase().includes(q)) ||
          (d.uploaded_date && d.uploaded_date.toLowerCase().includes(q)) ||
          (d.expires_date && d.expires_date.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.courseData = searchData;
      this.courseData = [...this.courseData];
    } else {
      this.courseData = [...this.courseDataRaw];
    }
  }

  resetSearch() {
    if (this.searchTerm) {
      this.searchTerm = '';
      this.courseData = [...this.courseDataRaw];
    }
  }

  onKeyUpChapter(query: string): void {
    console.log('this is query', query);
    if (query) {
      let q: string;
      q = query.toLowerCase();
      console.log('this is q==>', q);
      const searchData = this.selectedCourseChaptersRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag: any) => {
          if (tag.tag_name && tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.chapter_name && d.chapter_name.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.selectedCourseChapters = searchData;
      this.selectedCourseChapters = [...this.selectedCourseChapters];
    } else {
      this.selectedCourseChapters = [...this.selectedCourseChaptersRaw];
    }
  }
  resetSearchChapter() {
    if (this.searchTermChapter) {
      this.searchTermChapter = '';
      this.selectedCourseChapters = [...this.selectedCourseChaptersRaw];
    }
  }

  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  resetAcademyChapterForm(): void {
    // const is_activeValue = this.activeForm.get('is_active').value;

    this.academyChapterForm.reset();
    this.activeForm.get('is_active').setValue(true);
    // this.activeForm.get('is_active').patchValue(is_activeValue);

    this.questionForm.reset();
    this.checkboxChecked = false;
    this.updateModes = false;
    this.updateChapterId = undefined;
    this.rawUpdateDatas = {};
    this.resetChapterAttachments();
  }

  resetAcademyChapterUpdateForm(): void {
    const tagIds = this.getValidTagIds(this.rawUpdateDatas.tag);
    // this.selectedTagValues = this.tagFilterList.filter((tag) =>
    //   tagIds.includes(tag.value)
    // );
    this.academyChapterForm.controls.tag.setValue(tagIds);
    this.academyChapterForm.patchValue({
      chapter_name: this.rawUpdateDatas.chapter_name,
      description: this.rawUpdateDatas.description,
      content: this.rawUpdateDatas.content,
    });

    this.activeForm.patchValue({
      is_active: this.rawUpdateDatas.is_active,
    });
    // this.academyChapterForm.patchValue(this.rawUpdateDatas);
    const quizzes = this.rawUpdateDatas.quizzes || [];
    const firstQuiz = quizzes.length > 0 ? quizzes[0] : { questions: [] };
    const questions = firstQuiz.questions || [];

    this.questionForm.patchValue({
      quiz_name: firstQuiz.quiz_name, // Update quiz_name field
    });

    const questionsFormArray = this.questions;
    questionsFormArray.clear();

    questions.forEach((question: any) => {
      const questionGroup = this.createQuestionGroup(question);
      questionsFormArray.push(questionGroup);
    });

    this.loadChapterAttachmentsFromData(this.rawUpdateDatas);

    if (this.rawUpdateDatas.quizzes.length <= 0) {
      this.checkboxChecked = false;
    }
  }

  clickSwitch() {
    const isSwitchOn = this.activeForm.get('is_active').value;
    this.activeForm.get('is_active').setValue(!isSwitchOn);
  }

  createQuestionGroup(questionData: any): FormGroup {
    return this.fb.group({
      question_text: [questionData.question_text || '', Validators.required],
      options: this.fb.array(
        questionData.options.map((option: any) =>
          this.createOptionGroup(option)
        )
      ),
    });
  }

  createOptionGroup(optionData: any): FormGroup {
    return this.fb.group({
      is_correct_option: [optionData.is_correct_option || false],
      option_text: [optionData.option_text || ''],
    });
  }

  deleteCourse(courseId: number = null, multi = false): void {
    this.showLoad = true;
    let obj = {
      course_id: [courseId],
    };
    if (multi) {
      obj.course_id = [];
      obj.course_id = this.checkedDataCourse;
    }

    this.webapi.requestJson('deleteCourse', obj).subscribe(
      (data) => {
        let response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', 'Deletion successful.');
        this.getCourseList({ filters: [] });
        this.anyChecked = false;
      },
      (error) => {
        this.isLoading = false;
        this.createNotification(
          'error',
          '',
          'Something went wrong, please try again!'
        );
      }
    );
  }

  sendCourseIncompleteNotification(course: any): void {
    if (!course?.course_id) {
      return;
    }

    this.showLoad = true;
    this.webapi
      .requestJson('sendCourseIncompleteNotification', {
        course_id: course.course_id,
      })
      .subscribe(
        (data) => {
          const response = JSON.parse(data.body);
          this.showLoad = false;
          this.createNotification(
            'success',
            '',
            'Notification sent successfully.'
          );
        },
        () => {
          this.showLoad = false;
          this.createNotification(
            'error',
            '',
            'Something went wrong, please try again!'
          );
        }
      );
  }

  deleteChapter(chapterId: number = null, multi = false): void {
    this.showLoad = true;
    let obj = {
      chapter_id: [chapterId],
    };
    if (multi) {
      obj.chapter_id = [];
      obj.chapter_id = this.checkedData;
    }
    // store the chapter_path into new variable
    const course = this.courseData.filter(
      (course) => course.course_id === this.selectedCourseId
    );
    let chapters_path_Data = [];
    if (obj.chapter_id.length > 0) {
      course[0].chapters.forEach((chapter) => {
        if (obj.chapter_id.includes(chapter.chapter_id)) {
          if (chapter.attachments?.length) {
            chapter.attachments.forEach((attachment) => {
              if (attachment.file_path) {
                chapters_path_Data.push(attachment.file_path);
              }
            });
          } else if (chapter.chapter_path?.length > 0) {
            chapters_path_Data.push(chapter.chapter_path);
          }
        }
      });
    }
    console.log('chapter path', chapters_path_Data);
    if (chapters_path_Data.length > 0) {
      this.awsService
        .deleteFile(chapters_path_Data)
        .then((data) => {
          console.log('Response after Deleting item in chapterForm');

          this.webapi.requestJson('deleteChapter', obj).subscribe(
            (data) => {
              let response = JSON.parse(data.body);
              // this.isLoading = false;
              this.createNotification('success', '', 'Deletion successful.');
              this.getCourseList({ filters: [] }, this.selectedCourseId);
              // this.getCourseList({ filters: [] });
              this.allCheckedChapter = false;
            },
            (error) => {
              this.createNotification(
                'errror',
                '',
                'Something went wrong, please try again!'
              );
              this.getCourseList({ filters: [] }, this.selectedCourseId);
            }
          );
        })
        .catch((error) => {
          console.log('Error while deleting item(s)', error);
          this.createNotification(
            'errror',
            '',
            'Something went wrong, please try again!'
          );
          this.getCourseList({ filters: [] }, this.selectedCourseId);
        });
    } else {
      //if chapter_path is not null then delete attachment from AWS S3 & then remove from DB
      //else = > delete chapter_id directly from the DB

      this.webapi.requestJson('deleteChapter', obj).subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          // this.isLoading = false;
          this.createNotification('success', '', 'Deletion successful.');
          this.getCourseList({ filters: [] }, this.selectedCourseId);
          // this.getCourseList({ filters: [] });
          this.allCheckedChapter = false;
        },
        (error) => {
          this.createNotification(
            'errror',
            '',
            'Something went wrong, please try again!'
          );
          this.getCourseList({ filters: [] }, this.selectedCourseId);
        }
      );
    }
  }

  getMoreTagsContent(tags): string[] {
    return this.getDisplayTags(tags)
      .slice(2)
      .map((tag) => tag.tag_name);
  }

  /** Tags with a non-empty label for list/form display. */
  getDisplayTags(tags: any[] | null | undefined): any[] {
    return (tags || []).filter((tag) => this.hasTagLabel(tag));
  }

  /** Keep only tag ids that have a real label (skip empty/blank tags). */
  private getValidTagIds(tags: any[] | null | undefined): any[] {
    return (tags || [])
      .filter(
        (tag) =>
          this.hasTagLabel(tag) &&
          tag?.tag_id !== null &&
          tag?.tag_id !== undefined &&
          tag?.tag_id !== ''
      )
      .map((tag) => tag.tag_id);
  }

  private hasTagLabel(tag: any): boolean {
    const name = tag?.tag_name ?? tag?.name ?? tag?.text;
    return typeof name === 'string' ? name.trim().length > 0 : !!name;
  }

  /** Drop blank / whitespace-only values from free-text tag mode. */
  sanitizeTagFormValues(values: any[] | null | undefined): any[] {
    if (!Array.isArray(values)) {
      return [];
    }

    const optionLists = [
      ...(this.tagChapterFilterList || []),
      ...(this.tagCourseFilterList || []),
    ];
    const cleaned: any[] = [];
    const seen = new Set<string>();

    for (const value of values) {
      if (value === null || value === undefined) {
        continue;
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
          continue;
        }
        const key = `s:${trimmed.toLowerCase()}`;
        if (seen.has(key)) {
          continue;
        }
        seen.add(key);
        cleaned.push(trimmed);
        continue;
      }

      const option = optionLists.find(
        (item) => item.value === value || String(item.value) === String(value)
      );
      if (option && (!option.text || !String(option.text).trim())) {
        continue;
      }

      const key = `id:${String(value)}`;
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      cleaned.push(value);
    }

    return cleaned;
  }

  /** Drop blank values created via free-text tag mode. */
  onTagSelectionChange(
    controlName: 'tag',
    form: FormGroup,
    values?: any[]
  ): void {
    const control = form?.get(controlName);
    if (!control) {
      return;
    }

    const raw = Array.isArray(values) ? values : control.value;
    if (!Array.isArray(raw)) {
      return;
    }

    const cleaned = this.sanitizeTagFormValues(raw);
    const changed =
      cleaned.length !== raw.length ||
      cleaned.some((value, index) => value !== raw[index]);

    if (!changed) {
      return;
    }

    // Defer so nz-select finishes committing the blank chip, then remove it.
    setTimeout(() => {
      control.setValue(cleaned, { emitEvent: false });
    });
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }

  // clickFilter() {
  //   this.filterVisible = false;
  // }

  applyFilters() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }

    // if (this.active) {
    //   this.appliedFilters.push({ key: 'status', values: ['1'] });
    //   this.filterVisible = false;
    // }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
      this.isArchived = true;
    }
    this.getCourseList({ filters: this.appliedFilters });
    this.filterVisible = false;
  }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.clickFilter();
    }
    // else {}
  }

  clickFilter() {
    // this.getResourceList({ filters: [] });
    this.filterVisible = false;
    if (this.appliedFilters && this.appliedFilters.length > 0) {
      // this.isUsedInLast30Days = this.appliedFilters.some(filter => filter.values.includes('0'));
      // this.active = this.appliedFilters.some(filter => filter.values.includes('1'));
      this.archived = this.appliedFilters.some((filter) =>
        filter.values.includes('2')
      );
      console.log('this is archived', this.archived);
    } else {
      // this.isUsedInLast30Days = false;
      // this.active = false;
      this.resetFilter();
    }
  }
  resetFilter() {
    this.appliedFilters = [];
    this.archived = false;
    this.isArchived = false;
  }
  uncheckOtherOptions(questionIndex: number, selectedIndex: number) {
    const optionsArray = this.questionForm.get(
      `questions.${questionIndex}.options`
    ) as FormArray;
    optionsArray.controls.forEach((optionGroup, index) => {
      if (index !== selectedIndex) {
        optionGroup.get('is_correct_option').setValue(false);
      }
    });
  }

  onCheckboxChange(event: any): void {
    this.checkboxChecked = event.target.checked;
    if (!this.checkboxChecked) {
      this.questionForm.reset();
      // this.clearQuestions();
    }
  }
  clearFileList() {
    this.resetChapterAttachments();
  }

  onChange(event){
    console.log('event', event);
  }

  compareTimezones(o1, o2): boolean {
    return o1.display && o2.display && o1.value === o2.value;
  }

}
